import _Link from "@arco-design/web-react/es/Link";
import _Notification from "@arco-design/web-react/es/Notification";
import React from 'react';
var url = "https://cloudapi."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"/faas/services/ttrniynso13vagmg86/invoke/checkEnv";
var isExternalEnv = location.hostname === 'arco.design';
var key = 'hide_internal_notice';
var hideInternalNotice = localStorage.getItem(key);
if (isExternalEnv && !hideInternalNotice) {
  fetch(url).then(function () {
    _Notification.warning({
      duration: 0,
      id: key,
      content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "\u68C0\u6D4B\u60A8\u5904\u4E8E\u5185\u7F51\u73AF\u5883\uFF0C\u5982\u6709\u4E1A\u52A1\u9700\u6C42\uFF0C\u5EFA\u8BAE\u524D\u5F80", /*#__PURE__*/React.createElement(_Link, {
        href: "//arco."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"/themes",
        target: "_blank",
        hoverable: false
      }, "\u5185\u7F51\u7248")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Link, {
        onClick: function onClick() {
          localStorage.setItem(key, '1');
          _Notification.remove(key);
        },
        style: {
          marginTop: 20,
          fontSize: 12
        }
      }, "\u4E0D\u518D\u63D0\u793A")))
    });
  });
}